import { getAPIGatewayDataFromParent } from "../handler/ParentDataHandler";
import { logOperationalMetric } from "../overview/utils/utils";

/**
 * Simple API call wrapper using getAPIGatewayDataFromParent and logs metrics.
 */
function callAPI(request, setAsyncError, metricName, forceReturn) {
  const startTime = Date.now();
  return new Promise((resolve) => {
    getAPIGatewayDataFromParent(request)
      .then((result) => {
        const isSuccess = result.status === 200;
        logOperationalMetric(
          startTime,
          request.processName,
          metricName,
          isSuccess,
        );
        if (isSuccess) {
          resolve(result.data);
        } else {
          if (!forceReturn) {
            setAsyncError(`Result status: ${result.status}`);
          } else {
            resolve();
          }
        }
      })
      .catch((err) => {
        logOperationalMetric(startTime, request.processName, metricName, false);
        setAsyncError(err.toString());
      });
  });
}

/**
 * Calls the getQualityMetricsData API.
 */
function GET_QUALITY_METRICS_DATA(req, setAsyncError) {
  const request = {
    resourcePath: "/nevs/nevs/getQualityMetricsData",
    httpMethod: "POST",
    processName: "exceptions",
    requestBody: {
      filters: req.filters,
      metrics: req.metrics,
      startDate: req.startDate,
      endDate: req.endDate,
      stationCode: req.stationCode,
    },
  };
  return callAPI(request, setAsyncError, "getQualityMetricsData");
}

const api = {
  callAPI,
  GET_QUALITY_METRICS_DATA,
};

export default api;



// WEBPACK FOOTER //
// ./src/components/util/api.js